import { Table } from "../../s25-table/Table";
import { TableColumnI } from "../../../pojo/TableColumnI";

export namespace PricingColumns {
    const referenceColumn: Table.Column = { id: "reference", header: "Reference" };

    const amountColumns: Table.Column[] = [
        { id: "item", header: "Item" },
        { id: "listPrice", header: "List Price" },
        { id: "adjust", header: "Adjustments" },
        { id: "price", header: "Price" },
        { id: "tax", header: "Taxes" },
        { id: "total", header: "Total" },
    ];

    const invoiceToColumn: Table.Column = { id: "invoiceTo", header: "Invoice To" };

    const attributeColumns: Table.Column[] = [
        { id: "charge", header: "Charge To" },
        { id: "schedule", header: "Rate Schedule" },
        { id: "group", header: "Rate Group" },
        { id: "debit", header: "Debit Account" },
        { id: "credit", header: "Credit Account" },
    ];

    export function pricingColumns(combineRelated: boolean, invoiceTo = false): Table.Column[] {
        return [
            ...(combineRelated ? [referenceColumn] : []),
            ...amountColumns,
            ...(invoiceTo ? [invoiceToColumn] : []),
            ...attributeColumns,
        ];
    }

    /** The totals table shares the amount column ids so its cells line up with the org tables above it. */
    export function pricingTotalsColumns(): Table.Column[] {
        return [
            ...amountColumns,
            { id: "payments", header: "Payments" },
            { id: "balance", header: "Outstanding Balance", width: 120 },
            { id: "charge", header: "Charge To" },
        ];
    }

    export function toColumnChooserList(columns: Table.Column[], hiddenColumnIds: ReadonlySet<string>): TableColumnI[] {
        return columns.map((column) => {
            const visible = hiddenColumnIds.has(String(column.id)) ? 0 : 1;
            return {
                prefname: String(column.id),
                name: column.header,
                isVisible: visible,
                isDefaultVisible: visible,
                isPermanent: 0,
                sortable: 0,
                isDate: 0,
                isDateTime: 0,
                isTime: 0,
            } satisfies TableColumnI;
        });
    }
}
